import React, { useState } from 'react';

const CaseStudies = () => {
  const [activeCase, setActiveCase] = useState(0);

  const caseStudies = [
    {
      id: 1,
      title: 'Spekter Agency',
      client: '',
      challenge: 'Spekter Agency was gearing up to make a strong market entry with its launch, aiming to capture maximum mindshare within the Web3 and gaming ecosystem, drive player onboarding efficiently during launch, and establish a credible presence for long-term growth and partnership opportunities.',
      solution: `1️⃣ Content Distribution

We amplified Spekter Agency's launch story through:

• Targeted placements via trusted creators
• Messaging that highlighted value proposition and player benefits
• Multi-channel rollout to ensure broad ecosystem visibility

2️⃣ Community Activation & User Acquisition (UA)

To convert awareness into action, we executed a community-driven UA program:

• Incentivized early sign-ups and participation
• Coordinated launch events across Discord and social channels
• Community partnerships and game nights`,
      results: [
        { metric: '500K', label: 'Views Impression' },
        { metric: '9K', label: 'Total Engagement' },
        { metric: '1.77%', label: 'Engagement Rate' },
        { metric: '500K', label: 'Total Gamers' }
      ],
      services: ['Go-To-Market Strategy', 'KOL Activation & Management', 'Content Strategy & Messaging', 'Ecosystem & Partnership Connections', 'Strategic Advisory'],
      duration: '4 Months'
    },
    {
      id: 2,
      title: 'Overtake: Somnis Rush & TGE',
      client: '',
      challenge: 'Overtake was gearing up for the Somnis Rush and Golden Guardian main launch, aiming to acquire a large base of early, high-intent users, establish strong mindshare within the Web3 gaming and play-to-earn communities, and build sustained engagement leading into launch and beyond.',
      solution: `1️⃣ Content Distribution

• Curated content explaining gameplay mechanics and rewards
• Multi-channel placements to reach both core gamers and Web3 audiences
• Consistent messaging to position Overtake Somnis Rush as a must-play title

2️⃣ Community Activation & User Acquisition (UA)

To ensure impactful adoption, we executed a community-first UA strategy:

• Incentivized early users with exclusive in-game rewards and events
• Engaged community leaders and KOLs to drive authentic hype
• Coordinated launch events across Discord and social channels`,
      results: [
        { metric: '1M', label: 'Views Impression' },
        { metric: '20K', label: 'Total Engagement' },
        { metric: '3.5%', label: 'Engagement Rate' },
        { metric: '1M', label: 'Users Onboarded' }
      ],
      services: ['Go-To-Market Strategy', 'KOL Activation & Management', 'Content Strategy & Messaging', 'Ecosystem & Partnership Connections', 'Strategic Advisory'],
      duration: '3 Months'
    },
    {
      id: 3,
      title: 'Pixel Heroes Adventure',
      client: '',
      challenge: 'Pixel Heroes Adventure, a play-to-earn gaming project, was preparing for its grand launch and token activation. Their key goals were to maximize awareness and engagement around the Play-2-Airdrop event, drive adoption and usage of their $ADTV ecosystem token, and activate a highly engaged community ready to participate from day one.',
      solution: `1️⃣ Content Distribution

• Helped scale to 150k gamers, activating creators which helped with the initial launch and push
• Strategic storytelling around the Play-2-Airdrop mechanics and token utility
• Multi-channel creator placements for maximum reach
• Leveraged pre-existing relationships to secure competitive rates

2️⃣ Community Activation & User Acquisition (UA)

• Designed incentive-driven campaigns to onboard early adopters
• Coordinated token distribution events to maximize excitement and network effects
• Community partnerships and game nights were hosted with incentives to further boost user participation`,
      results: [
        { metric: '800K', label: 'Views Impression' },
        { metric: '19.7K', label: 'Total Engagement' },
        { metric: '2.36%', label: 'Engagement Rate' },
        { metric: '150K', label: 'Total Gamers' }
      ],
      services: ['Go-To-Market Strategy', 'KOL Activation & Management', 'Content Strategy & Messaging', 'Ecosystem & Partnership Connections'],
      duration: '2 Months'
    },
    {
      id: 4,
      title: 'Renaiss Protocol',
      client: '',
      challenge: 'Renaiss Protocol needed strategic advisory to optimize growth and market positioning. Key objectives were to refine go-to-market strategy and narrative positioning, identify key partnership and ecosystem opportunities, and align internal resources to accelerate growth and adoption.',
      solution: `1️⃣ Strategic Advisory

• Reviewed positioning and messaging to optimize market fit
• Provided recommendations for partnerships and strategic introductions to KOLs

2️⃣ Ecosystem & Partnership Connections

• Leveraged YP network to introduce Renaiss to potential partners, creators, and strategic collaborators

💡 Key Takeaways

• Advisory is most effective when combined with market insight and strategic connections
• Early alignment of narrative, partnerships, and execution sets the stage for measurable growth
• Experienced guidance can accelerate adoption and strengthen long-term credibility`,
      results: [
        { metric: 'Refined', label: 'GTM Strategy' },
        { metric: 'Strategic', label: 'Partnerships' },
        { metric: '10 Min', label: 'Pack Sellout Time' }
      ],
      services: ['KOL Activation & Management', 'Content Strategy & Messaging', 'Strategic Advisory'],
      duration: '6 Months'
    }
  ];

  return (
    <section id="case-studies" className="split-case-studies">
      {/* Section Header at the Top */}
      <div className="section-header">
        <div className="header-decoration">
          <div className="decoration-line"></div>
          <h2>Case Studies</h2>
          <div className="decoration-line"></div>
        </div>
        <p>Selected success stories</p>
      </div>

      <div className="split-container">
        {/* Left Navigation Panel - Compact */}
        <div className="split-navigation">
          <div className="cases-list">
            {caseStudies.map((caseStudy, index) => (
              <button
                key={caseStudy.id}
                className={`case-nav-item ${activeCase === index ? 'active' : ''}`}
                onClick={() => setActiveCase(index)}
              >
                <div className="case-number">0{index + 1}</div>
                <div className="case-preview">
                  <h3>{caseStudy.title}</h3>
                  <p>{caseStudy.client}</p>
                  <div className="case-meta">
                    <span className="duration">{caseStudy.duration}</span>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Right Content Panel */}
        <div className="split-content">
          <div className="content-scroll">
            <div className="case-details">
              <header className="case-header">
                <div className="client-info">
                  <h1>{caseStudies[activeCase].title}</h1>
                  <div className="client-subtitle">
                    <span className="client-name">{caseStudies[activeCase].client}</span>
                  </div>
                </div>
                <div className="case-stats">
                  <div className="stat">
                    <span className="stat-value">{caseStudies[activeCase].duration}</span>
                    <span className="stat-label">Duration</span>
                  </div>
                </div>
              </header>

              <div className="content-sections">
                {/* Objective Section */}
                <section className="content-section">
                  <h3>The Objective</h3>
                  <p>{caseStudies[activeCase].challenge}</p>
                </section>

                {/* Solution Section */}
                <section className="content-section">
                  <h3>How we helped</h3>
                  <p style={{ whiteSpace: 'pre-line' }}>{caseStudies[activeCase].solution}</p>
                </section>

                {/* Results Section */}
                <section className="content-section">
                  <h3>Results Delivered</h3>
                  <div className="results-grid">
                    {caseStudies[activeCase].results.map((result, index) => (
                      <div key={index} className="result-card">
                        <div className="result-value">{result.metric}</div>
                        <div className="result-label">{result.label}</div>
                      </div>
                    ))}
                  </div>
                </section>

                {/* Services Section */}
                <section className="content-section">
                  <h3>Services Provided</h3>
                  <div className="services-list">
                    {caseStudies[activeCase].services.map((service, index) => (
                      <div key={index} className="service-item">
                        <div className="service-icon">✓</div>
                        <span>{service}</span>
                      </div>
                    ))}
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;